import { HighlightModule } from "@/store/modules/highlights.module";
import { toaster } from "@/utilities/toaster";
import { Machine, assign } from "xstate";
const highlightMachine = Machine({
    id: "highlight",
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_HIGHLIGHTS: { target: "gettingHighlights", actions: "assignSearchData" },
            },
        },
        gettingHighlights: {
            invoke: {
                id: "gettingHighlights",
                src: (context, event) => {
                    return HighlightModule.GetHighlights(context.searchData);
                },
                onDone: { target: "loadedHighlight" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedHighlight: {
            on: {
                GETTING_HIGHLIGHTS: { target: "gettingHighlights", actions: "assignSearchData" },
                DELETE_HIGHLIGHT: { target: "deleteHighlight", actions: "ispageChanged" },
                ARCHIVE_HIGHLIGHT: { target: "archiveHighlight" },
                CANCEL: { target: "cancelHighlight" },
            },
        },
        deleteHighlight: {
            tags: "showHighlightDelete",
            on: {
                DELETING_HIGHLIGHT: { target: "deletingHighlight" },
                CANCEL: { target: "cancelHighlight" },
            },
        },
        deletingHighlight: {
            tags: "showHighlightDelete",
            invoke: {
                id: "deletingHighlight",
                src: (context, event) => {
                    return HighlightModule.Deletehighlight(event.highlightId);
                },
                onDone: { target: "gettingHighlights", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "serviceUnavailable" },
            },
        },
        archiveHighlight: {
            tags: "showArchiveHighlight",
            on: {
                ARCHIVING_HIGHLIGHT: { target: "archivingHighlight" },
                CANCEL: { target: "cancelHighlight" },
            },
        },
        archivingHighlight: {
            invoke: {
                id: "archiveHighlight",
                src: (context, event) => {
                    return HighlightModule.ArchiveHighLight({ isArchived: event.isArchived, highlightId: event.highlightId });
                },
                onDone: { target: "gettingHighlights", actions: "showSuccessMessage" },
                onError: { target: "serviceUnavailable" },
            },
        },
        cancelHighlight: {
            on: {
                CANCEL: { target: "loadedHighlight" },
                DELETE_HIGHLIGHT: { target: "deleteHighlight" },
                ARCHIVE_HIGHLIGHT: { target: "archiveHighlight" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    if (context.ispageChanged) {
                        const updatedSearchData = {
                            ...context.searchData,
                            page: context.searchData.page - 1,
                        };
                        HighlightModule.AssignSearchParams(updatedSearchData);
                        return updatedSearchData;
                    }
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default highlightMachine;
